import React, { useState, useEffect } from "react";
import { Col, Container, Row, Table } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import "react-bootstrap-typeahead/css/Typeahead.css";
import trasportApi from "../../api/trasportApi";
import PubSub from "pubsub-js";
import Select from "react-select";
import InfoPill from "../InfoPill";
import { FaTrashAlt } from "react-icons/fa";
import {
  DatatableWrapper,
  Filter,
  Pagination,
  PaginationOptions,
  TableBody,
  TableHeader,
} from "react-bs-datatable";
import { ShimmerTable } from "react-shimmer-effects";
import moment from "moment";
import Confirm from "../Confirm";

const SubjectEdit = (props) => {
  const [body, setBody] = useState([]);
  const [validated, setValidated] = useState(false);
  const [isVechile, setBranch] = useState(
    props ? props.vechileRec : {}
  );
  const [selectedFinancialYear, setSelectedFinancialYear] = useState({});
  const [financialYearOption, setOptionFinancialYear] = useState({});
  const [modalShow, setModalShow] = React.useState(false);
  const [branchName, setChallanBranchName] = useState({});
  const [challanDate, setChallanDate] = useState({});
  const [fnyear, setFinancialYear] = useState({});
  const [vechicleName, setVechicleName] = useState({});
  const [linetemdata, setLineItemData] = useState(false);

  const [selectedAdvanceBranch, setSelectedAdvanceBranch] = useState({});
  const [advanceBranchOption, setOptionAdvanceBranchOption] = useState({});

  const [selectedChallan, setSelectedChallan] = useState({});
  const [challanOption, setOptionChallan] = useState({});

  const [selectedVechicle, setSelectedVechicle] = useState({});
  const [vechicleOption, setVechicleOption] = useState({});

  const [rows, setRows] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [selectedRows, setSelectedRows] = useState([]);
  const [totalInvoiceAmount, setTotalInvoiceAmount] = useState();
  const [editableTotalAmount, setEditableTotalAmount] = useState("");

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    const fnYear = await trasportApi.fetchAllActiveFinancialYears();
    const challanData = await trasportApi.fetchAllChallan();

    //Year
    if (fnYear && fnYear.length) {
      let ar = [];
      fnYear.forEach((item) => {
        ar.push({ value: item.id, label: item.name });
      });

      const currentMonth = new Date().getMonth() + 1; // getMonth() is zero-based
      const currentYear = new Date().getFullYear();
      let defaultOption;

      if (currentMonth >= 3) {
        // March is the 3rd month
        defaultOption = ar.find(
          (option) => option.label === `${currentYear}-${currentYear + 1}`
        );
      } else {
        defaultOption = ar.find(
          (option) => option.label === `${currentYear - 1}-${currentYear}`
        );
      }

      if (defaultOption) {
        setSelectedFinancialYear(defaultOption);
        setBranch({ ...isVechile, financial_year_id: defaultOption.value });
      } else if (props?.vechileRec) {
        const acc = ar.find(
          (acc) => acc.value === props.vechileRec.financial_year_id
        );
        setSelectedFinancialYear(acc);
      }
      setOptionFinancialYear(ar);
    } else {
      setOptionFinancialYear([]);
    }

    // Chalan Api Setup
    if (challanData && challanData.length) {
      let challanOption = challanData.map((item) => ({
        value: item.id,
        label: item.client_name,
        client_id: item.client_id,
      }));

      let uniqueLabels = new Set();
      challanOption = challanOption.filter((item) => {
        if (uniqueLabels.has(item.label)) {
          return false;
        }
        uniqueLabels.add(item.label);
        return true;
      });

      console.log(challanOption);

      let itemOption = challanData.map((item) => ({
        value: item.item_id,
        label: item.item_name,
      }));

      let uniqueLabelss = new Set();
      itemOption = itemOption.filter((item) => {
        if (uniqueLabelss.has(item.label)) {
          return false;
        }
        uniqueLabelss.add(item.label);
        return true;
      });

      console.log(itemOption);

      // Handle vehicle-related logic
      if (props.vechileRec.id && props.vechileRec) {
        let obj = challanOption.filter(
          (acc) => acc.client_id === props.vechileRec.client_id
        );
        setSelectedChallan(obj);
        console.log("obj",obj)
        if (props.vechileRec.id && props.vechileRec.client_id) {
          console.log("Client Id If Called");
          const clientInvoiceLineItems = await trasportApi.fetchByClientId(props.vechileRec.client_id);
          console.log("clientInvoiceLineItems",clientInvoiceLineItems)
          if (clientInvoiceLineItems.success === true) {
            setBody(clientInvoiceLineItems.driversRecords);
            setLineItemData(true);
          }
        }
        
        
      }

      if (props.vechileRec.id && props.vechileRec) {
        let acc = itemOption.filter(
          (acc) => acc.value === props.vechileRec.item_id
        );
        console.log("acc", acc);
        setSelectedAdvanceBranch(acc);
      }

      setOptionChallan(challanOption || []);
      setOptionAdvanceBranchOption(itemOption || []);
    } else {
      setOptionChallan([]);
      setOptionAdvanceBranchOption([]);
    }
  };

  // Update the totalInvoiceAmount whenever selectedRows changes
  useEffect(() => {
    setTotalInvoiceAmount(calculateTotalAmount());
    setEditableTotalAmount(calculateTotalAmount());
  }, [selectedRows]);

  // const checkRequiredFields = () => {
  //   if (
  //     isVechile.vehicle_number &&
  //     isVechile.vehicle_number.trim() !== "" &&
  //     isVechile.transporter_id &&
  //     isVechile.transporter_id.trim() !== "" &&
  //     isVechile.rc_owner &&
  //     isVechile.rc_owner.trim() !== "" &&
  //     isVechile.financial_year_id &&
  //     isVechile.financial_year_id.trim() !== ""
  //   ) {

  //     return false;
  //   }
  //   return true;
  // };

  // Function to calculate the total amount based on client_balance
  const calculateTotalAmount = () => {
    return selectedRows.reduce((sum, record) => {
      return sum + (Number(record.client_balance) || 0);
    }, 0);
  };

  const handleSubmit = async (e) => {
    // console.log("isVechileisVechileisVechile", isVechile);
    e.preventDefault();

    isVechile.challan_id = selectedChallan.value;
    isVechile.total_invoice_amount = editableTotalAmount;
    // isVechile.challan_invoice_status = 'Pending';

    console.log("sdfs", selectedChallan.id);
    // if (checkRequiredFields()) {
    //   setValidated(true);
    //   return;
    // }
    let result2 = {};
    let invoiceLineItems = {};

    if (isVechile.id) {
      result2 = await trasportApi.saveClientInvoice(isVechile);
      for (const row of selectedRows) {
        try {
          invoiceLineItems = await trasportApi.createClientInvoiceLineItems(row);
          console.log("Inserted:", invoiceLineItems);
        } catch (error) {
          console.error("Error inserting row:", row, error);
        }
      }
      if (result2.success) {
        PubSub.publish("RECORD_SAVED_TOAST", {
          title: "Record Saved",
          message: "Record Updated successfully",
        });
        // fetchAllAdvanceChallanRecords(result2);
      }
    } else {
      console.log("d", selectedRows);

      result2 = await trasportApi.createClientInvoice(isVechile);
      for (const row of selectedRows) {
        try {
          invoiceLineItems = await trasportApi.createClientInvoiceLineItems(row);
          console.log("Inserted:", invoiceLineItems);
        } catch (error) {
          console.error("Error inserting row:", row, error);
        }
      }

      if (result2?.id && invoiceLineItems.id) {
        PubSub.publish("RECORD_SAVED_TOAST", {
          title: "Record Saved",
          message: "Record saved successfully",
        });
        fetchAllAdvanceChallanRecords(result2);
      } else {
        //submitDoctorDuties();
        //PubSub.publish('RECORD_ERROR_TOAST', { title: 'Record ERROR', message: result2.errors[0].msg });
      }
    }
  };

  const handlefinancialYear = (e) => {
    setSelectedFinancialYear(e);
    setBranch({ ...isVechile, financial_year_id: e.value });
  };

  const handleChallan = (e) => {
    setSelectedChallan(e);
    setBranch({ ...isVechile, challan_id: e.value });
  };

  const handleItem = (e) => {
    setSelectedAdvanceBranch(e);
    setBranch({ ...isVechile, item_id: e.value });
  };

  const handleVechile = async (e) => {
    let vechicleId = e;
    if (vechicleId) {
      setBranch({ ...isVechile, client_id: vechicleId.client_id });
      const challanRecData = await trasportApi.fetchChallanByClientId(
        vechicleId?.client_id
      );
      if (challanRecData && challanRecData.length) {
        //eslint-disable-next-line
        if (props?.vechileRec) {
          let acc = challanOption.filter(
            (acc) => acc.value === props.vechileRec.client_id
          );
          setSelectedChallan(acc);
        }
        setSelectedChallan(vechicleId);
        console.log("challanRecDatachallanRecData", vechicleId);
        setBody(challanRecData);
        // setRows(challanRecData);
      } else {
        setOptionChallan([]);
      }
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "total_invoice_amount") {
      // Allow empty string for clearing, and convert to number if not empty
      setEditableTotalAmount(value === "" ? "" : value);
      setBranch({
        ...isVechile,
        [name]: value === "" ? "" : Number(value),
      });
    } else if (name === "invoice_date") {
      // const selectedDate = new Date(value);
      // const today = new Date();
      // today.setHours(0, 0, 0, 0); // Reset today's time for comparison

      // if (selectedDate > today) {
      //   alert("Future Challan Date are not allowed."); // Display validation error
      //   // PubSub.publish('RECORD_ERROR_TOAST', { title: 'Future Challan Date are not allowed', message: "Future Challan Date are not allowed" });
      //   // return; // Stop further execution if validation fails
      // }
    } else {
      // For other fields, handle them generically
      setBranch({
        ...isVechile,
        [name]: value,
      });
    }

    console.log("isVechileisVechileisVechile21212112", isVechile);
  };

  // Function to handle saving the selected rows
  const handleSave = () => {
    console.log("selectedRows", selectedRows);
    // if (selectedRows.length > 0) {
    //   trasportApi.CreateLineItems(selectedRows)
    //     .then(response => {
    //       console.log("Rows inserted successfully:", response);
    //       setSelectedRows([]);
    //       setTotalInvoiceAmount(0);
    //     })
    //     .catch(error => {
    //       console.error("Error inserting rows:", error);
    //     });
    // } else {
    //   alert("Please select at least one row.");
    // }
  };

  const labels = {
    beforeSelect: " ",
  };

  const editFinancialYearList = (row) => {
    // setModalShowEditBranch(true);
    setBranch(row);
  };
  const handleDelete = (row) => {
    console.log(row);
    setModalShow(true);
    setBranch(row);
  };

  const isdelete = async () => {
    const result = await trasportApi.deleteClientInvoiceLineItems(isVechile.id);
    if (result.success) {
      setBranch("");
      setModalShow(false);
      fetchData();
      
    }
  };

  //Retrive Data From Server Backend When User Save or Create Records.

  const fetchAllAdvanceChallanRecords = async (result2) => {
    console.log("result2",result2);
    const result = await trasportApi.fetchClientInvoiceById(result2.id);
    if (result) {
      setBody(result);
    }
  };

  // Function to handle checkbox changes
  const handleSelectRecord = (record) => {
    console.log("RecordRow", record);
    if (selectedRows.includes(record)) {
      setSelectedRows(selectedRows.filter((r) => r !== record));
    } else {
      setSelectedRows([...selectedRows, record]);
    }
  };

  const handleSelectAll = () => {
    if (selectAll) {
      setSelectedRows([]);
    } else {
      setSelectedRows(body);
    }
    setSelectAll(!selectAll);
  };

  const header = [
    {
      title: "Financial Year",
      prop: "financial_year_name",
      isFilterable: true,
    },
    { title: "Branch Name", prop: "branch_name", isFilterable: true },
    { title: "Vehicle Number", prop: "vehicle_number", isFilterable: true },
    { title: "Client Name", prop: "client_name", isFilterable: true },
    {
      title: "Challan Date",
      prop: "challan_date",
      isSortable: true,
      isFilterable: true,
      cell: (row) => (
        <span>
          {row.challan_date
            ? moment(row.challan_date).format("DD MMM, yyyy")
            : ""}
        </span>
      ),
    },
    { title: "Challan No", prop: "challan_no", isFilterable: true },
    { title: "G.R. No", prop: "g_r_no", isFilterable: true },
    { title: "D.O. No", prop: "d_o_no", isFilterable: true },
    { title: "Consignee", prop: "consignee", isFilterable: true },
    {
      title: "Item Deduction Rate",
      prop: "item_deduction_rate",
      isFilterable: true,
    },
    { title: "From Station", prop: "from_station_id", isFilterable: true },
    { title: "To Station", prop: "to_station_id", isFilterable: true },
    { title: "Cement Bags", prop: "cement_bags", isFilterable: true },
    {
      title: "Client Commission Rate",
      prop: "client_commission_rate",
      isFilterable: true,
    },
    {
      title: "Client Commission Amount",
      prop: "client_commission_amount",
      isFilterable: true,
    },
    {
      title: "Commission Rate Per Ton",
      prop: "commission_rate_per_ton",
      isFilterable: true,
    },
    { title: "Commission", prop: "commission", isFilterable: true },
    { title: "Commission Fixed", prop: "commission_fixed", isFilterable: true },
    { title: "Grade", prop: "grade", isFilterable: true },
    { title: "Labour", prop: "labour", isFilterable: true },
    { title: "Constant Rate", prop: "constant_rate", isFilterable: true },
    { title: "Dispatch Weight", prop: "dispatch_weight", isFilterable: true },
    { title: "Rate", prop: "rate", isFilterable: true },
    { title: "Total Freight", prop: "total_freight", isFilterable: true },
    { title: "Actual Item Rate", prop: "actual_item_rate", isFilterable: true },
    {
      title: "Actual Total Freight",
      prop: "actual_total_freight",
      isFilterable: true,
    },
    { title: "Client Balance", prop: "client_balance", isFilterable: true },
    {
      title: "Last Modified Date",
      prop: "lastmodifieddate",
      isSortable: true,
      isFilterable: true,
      cell: (row) => (
        <span>
          {row.lastmodifieddate
            ? moment(row.lastmodifieddate).format("DD MMM, yyyy")
            : ""}
        </span>
      ),
    },
    {
      title: (
        <input type="checkbox" checked={selectAll} onChange={handleSelectAll} />
      ),
      prop: "checkbox",
      cell: (row) => (
        <input
          type="checkbox"
          checked={selectedRows.includes(row)}
          onChange={() => handleSelectRecord(row)}
        />
      ),
    },
  ];
  
  header.push({
    title: "Actions",
    prop: "id",
    cell: (row) => (
      <div style={{display: "inline-flex"}}>
        {linetemdata && props.vechileRec.id &&  (
        <Button
          variant="danger"
          className="btn-sm mx-1"
          onClick={() => handleDelete(row)}
        >
          <FaTrashAlt />
        </Button>
      )}
      </div>
    ),
  });

  return (
    <Modal {...props} size="xl" style={{ maxWidth: "100%" }}>
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title">
          Client Invoice Information
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container className="view-form">
          <Row>
            <Col lg={12}>
              <Form
                className="mt-3"
                onSubmit={handleSubmit}
                controlId="subjectCreate"
                noValidate
                validated={validated}
              >
                <Row>
                  <Col lg={6}>
                    <Form.Group className="mx-3">
                      <Form.Label className="form-view-label">
                        Client Invoice Financial Year
                      </Form.Label>
                      <Select
                        required
                        className="custom-select username"
                        placeholder="Select Financial Year"
                        value={selectedFinancialYear}
                        onChange={handlefinancialYear}
                        options={financialYearOption}
                      ></Select>
                      <Form.Control.Feedback type="invalid">
                        Please Select Financial Year.
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <Form.Group className="mx-3">
                      <Form.Label className="form-view-label">
                        Client/Party Name
                      </Form.Label>
                      <Select
                        required
                        className="custom-select username"
                        placeholder="Select Client Name"
                        value={selectedChallan}
                        onChange={handleVechile}
                        options={challanOption}
                      ></Select>
                      <Form.Control.Feedback type="invalid">
                        Please Select Challan Number.
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <Form.Group className="mx-3">
                      <Form.Label className="form-view-label">
                        Item Name
                      </Form.Label>
                      <Select
                        required
                        className="custom-select username"
                        placeholder="Select Item Name"
                        value={selectedAdvanceBranch}
                        onChange={handleItem}
                        options={advanceBranchOption}
                      ></Select>
                      <Form.Control.Feedback type="invalid">
                        Please Select Challan Number.
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <Form.Group className="mx-3">
                      <Form.Label className="form-view-label">
                        Invoice Date
                      </Form.Label>
                      <Form.Control
                        type="date"
                        name="invoice_date"
                        placeholder="Enter Your Invoice Date"
                        value={
                          isVechile ? moment(isVechile.invoice_date).format("YYYY-MM-DD"): "" }
                        onChange={handleChange}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <Form.Group className="mx-3">
                      <Form.Label className="form-view-label">
                        Invoice Number
                      </Form.Label>
                      <Form.Control
                        type="text"
                        name="invoice_number"
                        placeholder="Enter Invoice Number"
                        value={isVechile.invoice_number}
                        onChange={handleChange}
                        style={{ height: "38px" }}
                      />
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <Form.Group className="mx-3">
                      <Form.Label className="form-view-label">
                        Total Amount
                      </Form.Label>
                      <Form.Control
                        disabled
                        type="number"
                        placeholder="Enter Total Invoice Amount"
                        value={totalInvoiceAmount}
                        onChange={handleChange}
                        style={{ height: "38px" }}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please Enter Advance Amount.
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <Form.Group className="mx-3">
                      <Form.Label className="form-view-label">
                        Grand Total Amount
                      </Form.Label>
                      <Form.Control
                        type="number"
                        name="total_invoice_amount"
                        placeholder="Grand Total Invoice Amount"
                        value={
                          editableTotalAmount ||
                          props.vechileRec.total_invoice_amount
                        }
                        onChange={handleChange}
                        style={{ height: "38px" }}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please Enter Advance Amount.
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col lg={4} className="mx-2" style={{marginLeft : ""}}>
                  <Form.Group>
                    <Form.Label
                      className="form-view-label"
                      htmlFor="paymentType"
                    >
                     Select Client Invoice Status
                    </Form.Label>
                    <Form.Control
                      as="select"
                      id="paymentType"
                      name="challan_invoice_status"
                      className="form-view-label"
                      value={isVechile.challan_invoice_status || ""}
                      onChange={handleChange}
                    >
                      {/* <option value="">--Select--</option> */}
                      <option selected value="Pending">Pending</option>
                      <option value="Completed">Completed</option>
                    </Form.Control>
                  </Form.Group>
                </Col>
                </Row>
              </Form>
            </Col>
          </Row>
          <Row>
            {modalShow && (
              <Confirm
                show={modalShow}
                onHide={() => setModalShow(false)}
                isdelete={isdelete}
                title="Confirm delete?"
                message="You are going to delete the record. Are you sure?"
                table="Vehicle"
              />
            )}
            <Col lg={12} className="p-lg-4">
              {body && Object.keys(body).length > 0 ? (
                <Row>
                  <Col className="view-form-header align-items-center" lg={12}>
                    Challan Information
                  </Col>

                  <DatatableWrapper
                    body={body}
                    headers={header}
                    paginationOptionsProps={{
                      initialState: {
                        rowsPerPage: 10,
                        options: [5, 10, 15, 20],
                      },
                    }}
                  >
                    <div style={{ overflowX: "auto" }}>
                      <Table
                        striped
                        className="data-table mt-2"
                        style={{ width: "100%", tableLayout: "auto" }}
                      >
                        <TableHeader />
                        <TableBody />
                      </Table>
                    </div>
                    <Pagination />
                  </DatatableWrapper>
                </Row>
              ) : (
                ""
              )}
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide} variant="light">
          Cancel
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
export default SubjectEdit;
